
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import * as R from 'ramda';
import React, { useEffect } from "react";
import { InputNumerico } from "../inputs/InputNumerico";

//const estiloDescontos = require("./alterarValorNotaCreditoCancelamento.module.scss").default;
const estiloTabela = require('../../estilos/tabelas.module.scss').default

export type ValoresNotaCredito = {
    ValorProdutosOriginal: number,
    ValorFreteDespesasOriginal: number,
    ValorTotalCreditoOriginal: number,
    ValorProdutosGerar: number,
    ValorFreteDespesasGerar: number,
    ValorTotalCreditoGerar: number
}

export type AlterarValorNotaCreditoCancelamentoProps = {
  dadosValoresNotaCredito: ValoresNotaCredito;
  onConfirmar: (dadosValoresNotaCredito: ValoresNotaCredito) => void;
  onErrorValidacao: (erroValoresNotaCredito: FormikErrors<ValoresNotaCredito>) => void;
  somenteLeitura: boolean
};

export const AlterarValorNotaCreditoCancelamento = (props: AlterarValorNotaCreditoCancelamentoProps) => {

  const formik = useFormik({
    initialValues: { ...props.dadosValoresNotaCredito },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
    validate: (values) => onValidarDadosFormulario(values)
  });

  const onValidarDadosFormulario = async (desconto: ValoresNotaCredito) => {
    const mensagemDescontoSuperiorOriginal = (campo: string) => `Desconto da "${campo}" superior ao valor original.`
    const mensagemDescontoSuperiorValorMaximo = (campo: string) => `Desconto da "${campo}" superior ao valor máximo permitido.`
    const mensagemDescontoMenorQueZero = (campo: string) => `Desconto do "${campo}" não pode ser menor que 0.`

    //return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
    // DescontoAdicionalProdutoComOferta: desconto.DescontoAdicionalProdutoComOferta > 100 ? mensagemDescontoSuperiorValorMaximo("Produtos em Oferta") :
   // desconto.DescontoAdicionalProdutoComOferta < 0 ? mensagemDescontoMenorQueZero("Produtos em Oferta") : undefined,

    //DescontoAdicionalProdutoSemOferta: desconto.DescontoAdicionalProdutoSemOferta > 100 ? mensagemDescontoSuperiorValorMaximo("Produtos sem Oferta") :
      //desconto.DescontoAdicionalProdutoSemOferta < 0 ? mensagemDescontoMenorQueZero("Produtos sem Oferta") : undefined,

    //DescontoFretePorContaDestinatario: desconto.DescontoFretePorContaDestinatario > desconto?.DescontoFretePorContaDestinatarioOriginal ? mensagemDescontoSuperiorOriginal("Tipo de Frete (FOB)") :
     // desconto.DescontoFretePorContaDestinatario < 0 ? mensagemDescontoMenorQueZero("Tipo de Frete (FOB)") : undefined,

   //DescontoMaximoFormaPagamento: desconto.DescontoMaximoFormaPagamento > desconto?.DescontoMaximoFormaPagamentoOriginal ? mensagemDescontoSuperiorOriginal("Forma de Pagamento") :
   // desconto.DescontoMaximoFormaPagamento < 0 ? mensagemDescontoMenorQueZero("Forma de Pagamento") : undefined,

    //DescontoPorFaixaValorVenda: desconto.DescontoPorFaixaValorVenda > desconto?.DescontoPorFaixaValorVendaOriginal ? mensagemDescontoSuperiorOriginal("Valor Total da Mercadoria") :
    //  desconto.DescontoPorFaixaValorVenda < 0 ? mensagemDescontoMenorQueZero("Valor Total da Mercadoria") : undefined,
  //} as FormikErrors<ValoresNotaCredito>)
  }

  const onValidarDadosDescontos = async () => {
    await formik.validateForm(formik.values)
  }

  const dadosValoresNotaCreditoOriginal = () => {
    const produto = <div>
      <label>Valor dos Produtos</label>
      <InputNumerico disabled numeroCasasDecimais={2} valor={formik.values?.ValorProdutosOriginal ?? 0} />
    </div>

    const fretedespesa = <div>
      <label>Valor Frete / Despesas</label>
      <InputNumerico disabled numeroCasasDecimais={2} valor={formik.values?.ValorFreteDespesasOriginal ?? 0} />
    </div>

    const total = <div>
      <label>Valor Total do Crédito</label>
      <InputNumerico disabled numeroCasasDecimais={2} valor={formik.values?.ValorTotalCreditoOriginal ?? 0} />
    </div>

    return <div className={estiloTabela.formulario}>
      <label className={estiloTabela.titulo}>Valor do Crédito Original</label>
      <div className={estiloTabela.itensAEsquerda}>
        <div className={estiloTabela.input}>
          {produto}
          {fretedespesa}
          {total}
        </div>
      </div>
    </div>
  }

  const dadosValoresNotaCreditoGerar = () => {
    const produto = <div>
      <label>Valor dos Produtos</label>
      <InputNumerico
        disabled={props.somenteLeitura}
        style={formik.errors. ValorProdutosGerar != undefined ? { borderColor: "#f25713", color: "#f25713" } : {}}
        numeroCasasDecimais={2}
        selecionaValorOnFocus={true}
        valor={formik.values?.ValorProdutosGerar ?? 0}
        onValorModificado={(valorModificado) => formik.setFieldValue("ValorProdutosGerar", valorModificado)} />
    </div>

    const fretedespesa = <div>
      <label>Valor Frete / Despesas</label>
      <InputNumerico
        disabled={props.somenteLeitura}
        style={formik.errors.ValorFreteDespesasGerar != undefined ? { borderColor: "#f25713", color: "#f25713" } : {}}
        numeroCasasDecimais={2}
        selecionaValorOnFocus={true}
        valor={formik.values?.ValorFreteDespesasGerar ?? 0}
        onValorModificado={(valorModificado) => formik.setFieldValue("ValorFreteDespesasGerar", valorModificado)} />
    </div>

    const total = <div>
        <label>Valor Total do Crédito</label>
        <InputNumerico disabled numeroCasasDecimais={2} valor={formik.values?.ValorTotalCreditoGerar ?? 0} />
    </div>

      return <div className={estiloTabela.formlario}>
      <label className={estiloTabela.titulo}>Valor do Crédito a ser gerado </label>
      <div className={estiloTabela.itensAEsquerda}>
        <div className={estiloTabela.imput}>
          {produto}
          {fretedespesa}
          {total}
        </div>
      </div>
    </div>
  }

  const buttonAplicaDesconto = <div>
    <button className={estiloTabela.botoes}
      onClick={async () => {
        const erros = await formik.validateForm(formik.values)
        if (Object.keys(erros).length == 0) {
          props.onConfirmar(formik.values)
        } else {
          props.onErrorValidacao(erros)
        }
      }}
    >
      Confirmar
    </button>
  </div>

 
  return (
    <>
      <div className={`_mt-4 _grid _grid-cols-1 min-[992px]:_grid-cols-2`}>
        {dadosValoresNotaCreditoOriginal()}
        {dadosValoresNotaCreditoGerar()}
      </div>

      <div className={estiloTabela.botoes}>
        {buttonAplicaDesconto}
      </div>
    </>
  );
};
